<template>
  <div class="insert" v-on:scroll.passive="testScroll" :class="data.ambient == true ? 'ambientada' : 'fullwidth'" :style="data.myWidth && !isMobile ? 'width:'+data.myWidth+'px;':''">
    <div class="swipeme" v-show="$parent.$parent.viewBar">
      <img src="static/7635-swipe-left.gif" class="swipeme-img">
      <p>DESLIZA</p>
    </div>
    <HotSpotComponent :key="'p' + index" :indice="indice" :x="hotspot.positionX" :y="hotspot.positionY" :ancho="data.originalWidth" :alto="data.originalHeight" type="product" :enlace="'hotspot.sku'" :content="hotspot.sku ? hotspot.sku : 0" :category="category" :ambient="data.ambient" :image="data.background" v-for="(hotspot, index) in data.content.products" :finalW="finalWidth" :finalH="finalHeight"/>
    <HotSpotComponent :key="'l' + index" :indice="indice" :x="hotspot.positionX" :y="fixY(hotspot.positionY)" type="link" :enlace="hotspot.link" :category="category" :ambient="data.ambient" :image="data.background" v-for="(hotspot, index) in data.content.links"/>
    <HotSpotComponent :key="'m' + index" :indice="indice" :x="hotspot.positionX" :y="hotspot.positionY" :w="hotspot.sizeW" :h="hotspot.sizeH" type="invisible" :enlace="hotspot.link" v-for="(hotspot, index) in data.content.menus"/>
      <ImageItem :source="data.background ? data.background : ''" :size="imageSize" style="height:97%"></ImageItem>
  </div>
</template>
<script>
/* eslint-disable */
import HotSpotComponent from './HotSpotComponent'
import ImageItem from './ImageItem'
let scrollTimer2
export default {
  name: 'InsertComponent',
  inheritAttrs: false,
  props: {
    data: Object,
    indice: Number,
    category: String
  },
  computed: {
    imageSize () {
      if (this.data.ambient === true) {
        return 'height:100%;margin:0px;padding:0px;'
      } else {
        return 'width:100%;margin:0px;padding:0px;'
      }
    }
  },
  data () {
    return {
      showspot: false,
      originalSize: {},
      finalWidth: 0,
      finalHeight: 0,
      isMobile: this.$parent.$parent.isMobile,
      desliz:false
    }
  },
  methods: {
    fixY (val){
      if(this.data.ambient === true){
        return val * .97
      }else{
        return !this.isMobile ? val * .97 : val
      }
    },
    testScroll () {
      if(!this.desliz){
        dataLayer.push({
        'event': 'Interacción', // Acá se deja como evento de interacción
        'category': 'Deslizar', // Especificar que hace referencia a desliza
        'action': 'Desliz', // Hay que registrar la profundidad alcanzada
        'tag': this.data.background// Nombre del producto deslizado
        })
        this.desliz = true;
      }
      window.clearTimeout(scrollTimer2)
      this.$parent.$parent.viewBar = false
      // eslint-disable-next-line
      scrollTimer2 = setTimeout(() => this.$parent.$parent.viewBar = true, 1000)
    }
  },
  components: {
    HotSpotComponent,
    ImageItem
  },
  mounted () {
    console.log(this.isMobile)
    if (this.$parent.$parent.isMobile === false) {
      const full = document.querySelectorAll('.fullwidth')
      full.forEach(obj => {
        let newWidth = Math.round(((obj.offsetHeight * 0.96) * 750) / 1334)
        obj.style.width = newWidth + 'px'
      })
    }
    const { src, $el } = this

    const observer = new IntersectionObserver(([entry]) => {
      const img = $el.querySelector('img')
      let imgSwipe = false
      if (img.classList.contains('swipeme-img')) {
        imgSwipe = true
      }
      if (!imgSwipe) {
        if (entry.isIntersecting) {
          // Element is in viewport
          img.src = src
          observer.disconnect()
        }
      }
    })
    observer.observe($el)

    this.$once('hook:beforeDestroy', () => {
      observer.disconnect()
    })
  }
}
</script>
<style>
.app-img{
  margin:5px;
}
.hide{display:none}
  .insert{ position:relative;overflow-x:auto;width:100%;height:96vh;}
  .fullwidth{height:auto!important;}
  .swipeme{position:absolute;top: 38vh;right: 10px;z-index: 10;width: 130px;margin-left:-65px}
  .swipeme p{font-weight:bold;font-size:1.250em;margin-top:5px;color:#fff;}
  .swipeme-img{width:110px;opacity:.9;border-radius:100px;}
  .fullwidth .swipeme{display:none!important;}
  .image__wrapper{z-index:0}
  @media only screen and (min-width: 1000px) {
    .insert{height:100vh;width:auto;overflow:hidden}
    .fullwidth{height:100vh!important;width:auto;}
    .swipeme{display:none}
  }
</style>



// WEBPACK FOOTER //
// src/components/InsertComponent.vue